import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from 'src/app/services/inventory-service';
import { Entry } from 'src/app/models/entry';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { from } from 'rxjs';
import { groupBy, mergeMap, toArray, filter } from 'rxjs/operators';

@Component({
  selector: 'app-warehouse-history',
  templateUrl: './warehouse-history.component.html',
  styleUrls: ['./warehouse-history.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}],
})
export class WarehouseHistoryComponent implements OnInit {
  date1:Date = new Date();
  date2:Date = new Date();
  today:Date = new Date();
  entries:Entry[] = [];
  entriesFilter:any[] = [];
  loading:boolean = false;
  data = [];

  totalInPrice:number = 0;
  totalOutPrice:number = 0;

  constructor(private modal:NgbModal, private invServ:InventoryService, private utl:UtilitiesService, private toastr:ToastrManager) { }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.invServ.getEntriesByDates(this.date1, this.date2)
      .then(x => {
        this.entries = x.filter(x => x.status);
        this.calculate();
        this.loading = false;
      })
      .catch(err => {
        this.toastr.errorToastr(this.utl.formatMessages(err));
        this.loading = false;
      });
  }

  open(modal, articleId) {
    var tmp = [];

    this.entries.forEach(x => x.lines.forEach(y => {
      if (y.article_id == articleId) {
        tmp.push({
          entry_id: y.entry_id,
          quantity: y.quantity,
          unit_price: y.unit_price,
          total: y.unit_price * y.quantity,
          warehouse_user: x.user.name + ' ' + x.user.last_name,
          in_date: x.entry_date,
          out_user: y.deliver_to,
          out_date: this.compareDate(y.output_date) ? y.output_date : null,
        });
      }
    }));

    this.entriesFilter = tmp;
    this.modal.open(modal, {size: 'lg'});
  }

  calculate() {
    var tmp = [];
    this.entries.forEach(x => x.lines.forEach(y => tmp.push(y)));

    this.data = [];

    from(tmp).pipe(
      filter(x => x.warehouse_measure_unit != 'servicio'),
      groupBy(x => x.article_id),
      mergeMap(x => x.pipe(toArray())),
    ).subscribe(x => {
      let filter = x.filter(x => this.compareDate(x.output_date));
      let line = {
        article_id: x[0].article_id,
        article_name: x[0].article_name,
        unit_measure: x[0].warehouse_measure_unit,
        in: x.reduce((ant, act) => ant + Number(act.quantity), 0),
        in_price: x.reduce((ant, act) => ant + Number(act.quantity) * Number(act.unit_price), 0),
        out: filter.reduce((ant, act) => ant + Number(act.quantity), 0),
        out_price: filter.reduce((ant, act) => ant + Number(act.quantity) * Number(act.unit_price), 0),
      };

      this.data.push(line);

      this.totalInPrice += line.in_price;
      this.totalOutPrice += line.out_price;
    });
  }

  compareDate(date) {
    this.date2.setHours(23);
    this.date2.setMinutes(59);
    this.date2.setSeconds(59);
    this.date2.setMilliseconds(999);

    console.log(this.date2.toISOString());

    return date && new Date(date) <= this.date2;
  }
}
